<template>
  <div>
    <!-- 积分概览卡片 -->
    <el-card>
      <div class="overview">
        <div>
          <div class="ov-label">當前積分</div>
          <div class="ov-points">{{ $fmtPoints(points) }}</div>
          <div class="muted" style="font-size: 13px">每張圖 {{ $fmtPoints(minImage) }} 積分起 · 影片每秒 {{ $fmtPoints(minSecond) }} 積分起</div>
        </div>
        <div class="ov-right">
          <el-button type="primary" size="small" @click="goRecharge">去儲值</el-button>
          <div class="muted" style="font-size: 12px">1 TWD = {{ $fmtPoints(rate) }} 積分 · 每張圖 {{ $fmtPoints(minImage) }} 積分起 · 影片每秒 {{ $fmtPoints(minSecond) }} 積分起</div>
        </div>
      </div>
    </el-card>

    <!-- 明细 -->
    <el-card class="mt16">
      <el-tabs v-model="tab">
        <el-tab-pane label="積分明細" name="trans">
          <el-table :data="transactions" size="mini" empty-text="暫無明細">
            <el-table-column prop="created_at" label="時間" width="160" />
            <el-table-column label="類型" width="110">
              <template slot-scope="s">{{ typeLabel(s.row.type) }}</template>
            </el-table-column>
            <el-table-column label="積分" width="100">
              <template slot-scope="s">
                <span :class="s.row.points >= 0 ? 'plus' : 'minus'">
                  {{ s.row.points >= 0 ? '+' : '' }}{{ $fmtPoints(s.row.points) }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="說明" />
          </el-table>
          <el-pagination
            v-if="transTotal > pageSize"
            background
            style="margin-top:10px;text-align:right"
            layout="prev, pager, next"
            :total="transTotal"
            :page-size="pageSize"
            @current-change="loadTrans"
          />
        </el-tab-pane>
        <el-tab-pane label="儲值記錄" name="recharge">
          <el-table :data="recharges" size="mini" empty-text="暫無儲值記錄">
            <el-table-column prop="created_at" label="時間" width="160" />
            <el-table-column prop="order_no" label="訂單號" width="180" />
            <el-table-column label="金額" width="110">
              <template slot-scope="s">
                {{ s.row.currency === 'CNY' ? '¥' : 'NT$' }} {{ s.row.amount }}
              </template>
            </el-table-column>
            <el-table-column label="獲得積分">
              <template slot-scope="s">{{ $fmtPoints(s.row.points) }}</template>
            </el-table-column>
            <el-table-column label="狀態" width="90">
              <template slot-scope="s">
                <el-tag size="mini" :type="s.row.status === 'paid' ? 'success' : (s.row.status === 'pending' ? 'warning' : 'info')">
                  {{ { pending: '待付款', paid: '已到帳', failed: '失敗', refunded: '已退款' }[s.row.status] || s.row.status }}
                </el-tag>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            v-if="rechargeTotal > pageSize"
            background
            style="margin-top:10px;text-align:right"
            layout="prev, pager, next"
            :total="rechargeTotal"
            :page-size="pageSize"
            @current-change="loadRecharges"
          />
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import { fetchBalance, fetchTransactions, fetchRecharges } from '../api/user'

export default {
  name: 'Profile',
  data() {
    return {
      tab: 'trans',
      points: 0,
      rules: { per_image: 10, per_second: 2, cny_rate: 1, twd_rate: 1,
        per_image_min: 0, per_second_min: 0 },
      transactions: [],
      transTotal: 0,
      recharges: [],
      rechargeTotal: 0,
      pageSize: 15
    }
  },
  computed: {
    /** 充值汇率：在线支付是台币（twd_rate），老数据是人民币（cny_rate）。占位兜底按 1:1 */
    rate() {
      return this.rules.twd_rate || this.rules.cny_rate || 1
    },
    /**
     * 展示用的「每張圖 N 積分起」：取后端算出的**最低价**（价表里最小的那一档）。
     * 实际按「模型 × 解析度 × 比例」查价、客户级还可能覆盖，所以只会 ≥ 这个数，才写「起」。
     * 老后端不返回 per_image_min 时回退基准价，至少不会显示成空。
     */
    minImage() {
      const v = this.rules.per_image_min
      return v > 0 ? v : this.rules.per_image
    },
    minSecond() {
      const v = this.rules.per_second_min
      return v > 0 ? v : this.rules.per_second
    }
  },
  created() {
    this.loadAll()
  },
  methods: {
    /** 去儲值页（在线支付：下单 → 跳转蓝新付款页 → 回调入账） */
    goRecharge() {
      this.$router.push('/recharge')
    },
    async loadAll() {
      try {
        const b = await fetchBalance()
        this.points = b.points
        this.rules = { per_image: b.per_image, per_second: b.per_second,
          cny_rate: b.cny_rate || 1, twd_rate: b.twd_rate || b.cny_rate || 1,
          per_image_min: b.per_image_min, per_second_min: b.per_second_min }
      } catch (e) { /* token 失效由拦截器处理 */ }
      this.loadTrans(1)
      this.loadRecharges(1)
    },
    async loadTrans(page) {
      try {
        const d = await fetchTransactions({ page, pageSize: this.pageSize })
        this.transactions = d.list
        this.transTotal = d.total
      } catch (e) { /* ignore */ }
    },
    async loadRecharges(page) {
      try {
        const d = await fetchRecharges({ page, pageSize: this.pageSize })
        this.recharges = d.list
        this.rechargeTotal = d.total
      } catch (e) { /* ignore */ }
    },
    typeLabel(t) {
      // 與後端 PointKit.typeDesc 保持同一套說法（後加的類型別漏 —— 漏了會直接顯示英文 key）
      const map = {
        recharge: '儲值',
        consume_image: '生成圖片',
        consume_video: '生成影片',
        consume_reverse_prompt: 'AI 反推提示詞',
        consume_upscale: '影片畫質提升',
        consume_subtitle: 'AI 字幕',
        consume_erase_subtitle: 'AI 去字幕',
        consume_voice: 'AI 語音',
        consume_dub: '影片自動配音',
        consume_text: 'AI 生文',
        signup_bonus: '註冊贈送'
      }
      return map[t] || t || '其他'
    }
  }
}
</script>

<style scoped>
.overview {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.ov-label {
  color: var(--c-text-3);
  font-size: 13px;
}
.ov-points {
  font-size: 40px;
  font-weight: 700;
  color: var(--c-primary-ink);
  line-height: 1.2;
}
.ov-right {
  text-align: right;
}
.ov-right .el-button {
  margin-bottom: 8px;
}
.muted { color: var(--c-text-3); }
.plus { color: var(--c-primary-ink); font-weight: 600; }
.minus { color: var(--c-danger); font-weight: 600; }
.mt16 { margin-top: 16px; }
.mt10 { margin-top: 10px; }
</style>
